export default function SafetySection() {
  return (
    <section id="safety" className="py-20 md:py-28 bg-background-50">
      <div className="w-full max-w-4xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <p className="font-label text-xs text-primary-600 tracking-[0.2em] uppercase mb-3">
            Your Safety Matters
          </p>
          <h2 className="section-title mb-3">
            Safe Shopping Research Starts Here
          </h2>
          <p className="section-subtitle mx-auto">
            We are committed to providing a secure and transparent resource platform for all shoppers.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <div className="flex gap-4 p-5 rounded-xl bg-background-100 border border-background-200">
            <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center flex-shrink-0">
              <i className="ri-information-line text-lg text-primary-500"></i>
            </div>
            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-1">
                Independent Information Platform
              </h4>
              <p className="font-body text-sm text-foreground-500 leading-relaxed">
                We are an independent resource platform and are not affiliated with any specific brand or marketplace. Our goal is to provide helpful product research information.
              </p>
            </div>
          </div>

          <div className="flex gap-4 p-5 rounded-xl bg-background-100 border border-background-200">
            <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center flex-shrink-0">
              <i className="ri-lock-line text-lg text-primary-500"></i>
            </div>
            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-1">
                No Payment Collection
              </h4>
              <p className="font-body text-sm text-foreground-500 leading-relaxed">
                This website does not collect any payments or financial information. All transactions happen on the linked platforms you choose to visit.
              </p>
            </div>
          </div>

          <div className="flex gap-4 p-5 rounded-xl bg-background-100 border border-background-200">
            <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center flex-shrink-0">
              <i className="ri-shield-user-line text-lg text-primary-500"></i>
            </div>
            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-1">
                Privacy Protection
              </h4>
              <p className="font-body text-sm text-foreground-500 leading-relaxed">
                We respect your privacy and do not collect personal data without consent. Browsing our resource platform is completely anonymous and secure.
              </p>
            </div>
          </div>

          <div className="flex gap-4 p-5 rounded-xl bg-background-100 border border-background-200">
            <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center flex-shrink-0">
              <i className="ri-global-line text-lg text-primary-500"></i>
            </div>
            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-1">
                Secure Browsing
              </h4>
              <p className="font-body text-sm text-foreground-500 leading-relaxed">
                Our website uses HTTPS encryption for all data transmission. External links are clearly marked and open in new tabs with proper security attributes.
              </p>
            </div>
          </div>

          <div className="flex gap-4 p-5 rounded-xl bg-background-100 border border-background-200">
            <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center flex-shrink-0">
              <i className="ri-file-text-line text-lg text-primary-500"></i>
            </div>
            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-1">
                Third-Party Service Disclaimer
              </h4>
              <p className="font-body text-sm text-foreground-500 leading-relaxed">
                We link to third-party websites for your convenience. We are not responsible for the content, policies, or transactions on external platforms.
              </p>
            </div>
          </div>

          <div className="flex gap-4 p-5 rounded-xl bg-background-100 border border-background-200">
            <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center flex-shrink-0">
              <i className="ri-user-voice-line text-lg text-primary-500"></i>
            </div>
            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-1">
                User Responsibility
              </h4>
              <p className="font-body text-sm text-foreground-500 leading-relaxed">
                Shoppers should always conduct their own research before making purchases. Use our resources as a starting point, not as the sole basis for buying decisions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}